import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";

import { Home } from "./pages/home/Home";
import { webflowJs } from "./webflow.js";

// Webflow re-initialization on route change
const ScrollToTopAndInitWebflow = () => {
  const location = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);

    // Load Webflow script dynamically
    const loadWebflowScript = async () => {
      try {
        await webflowJs;

        if (window.Webflow && window.Webflow.ready) {
          window.Webflow.ready();
          if (window.Webflow.require) {
            const ix2 = window.Webflow.require("ix2");
            if (ix2 && ix2.init) {
              ix2.init();
            }
          }
        }
      } catch (error) {
        console.error("Webflow script failed to load:", error);
      }
    };

    loadWebflowScript();
  }, [location.pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTopAndInitWebflow />
      <Routes>
        <Route path="/" element={<Home />} />
       
      </Routes>
    </Router>
  );
}

export default App;
